import BaseTable from "../BaseTable";
import { FILTER_TYPE } from "@/constant/constants";
import LanguageModal from "@/Modals/LanguageManagement/Languages/Modal";
import { columns } from "./Columns";
import { languagesApi } from "@/apis/apis";
import { textDirectionFilters } from "@/constant/Languages/text-direction";

export default function LanguagesPage() {
  const textDirectionFiltersMap = textDirectionFilters();
  const additionalFilters = [
    {
      id: "filter[rtl]",
      label: "Text Direction",
      type: FILTER_TYPE.SELECT,
      options: textDirectionFiltersMap,
    },
  ];

  return (
    <BaseTable
      label="Language"
      apiURL={languagesApi}
      columns={columns()}
      ModalComponent={LanguageModal}
      importData={null}
      enableSortData={true}
      enableExport={false}
      confirmationModalTitleKey="title"
      additionalFilters={additionalFilters}
    />
  );
}
